import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    Input,
    Row,
    Label
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { UrlOpenTypes } from '../../data/UrlOpenType';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { gAPI_AllServices } from '../../../../../../constants/APIs';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';

export default function StandaloneExternalLink({
    pageSettings,
    saveIntegration,
    integrationProperties
}) {
    const [externalLinks, setExternalLinks] = useState([{
        title: '',
        link: '',
        option: ''
    }]);
    const [servicesData, setServicesData] = useState([]);
    const [selectedService, setSelectedService] = useState(null);
    useEffect(() => {
        if (integrationProperties !== undefined) {
            let data = {
                languageCode: "en",
                propertyId: integrationProperties
            };
            AxiosAPI({
                method: 'post',
                url: `${gAPI_AllServices}`,
                data: data
            }).then((res) => {
                const serviceData = res.data.services.filter((item) => item.status === "Active");
                var data = serviceData.map(k => { return { label: k.title, value: k.id } });
                setServicesData(data);
            }).catch((err) => console.log('err', err));
        }
    }, [pageSettings, integrationProperties]);

    useEffect(() => {
        if (pageSettings.externalLinks !== undefined && pageSettings.externalLinks.length > 0) {
            let links = [];
            pageSettings.externalLinks.map((m) => {
                if (m.option === "OpenContentItem") {
                    setSelectedService(servicesData.filter(m => m.value === m.link).map(k => { return k; }));
                }
                links.push({
                    title: m.title,
                    link: m.link,
                    option: m.option
                })
            });
            setExternalLinks(links);
        }
    }, [pageSettings]);

    const AddLinks = () => {
        let links = [...externalLinks];;
        links.push({
            title: '',
            link: '',
            option: ''
        });
        setExternalLinks(links);
    };

    const RemoveLinks = (index) => {
        const values = [...externalLinks];
        values.splice(index, 1);
        setExternalLinks(values);
    };

    const handleSave = () => {
        let setting = pageSettings;
        setting.externalLinks = externalLinks;
        saveIntegration({
            pageSettings: setting
        });
    };
    const handleChangeSelect = (selectedOptions, index) => {
        const values = [...externalLinks];
        values[index].link = selectedOptions.value;
        setExternalLinks(values);
    };

    const handleChange = (e, index) => {
        const values = [...externalLinks];
        if (e.target.name === 'title') {
            values[index].title = e.target.value;
        }
        else if (e.target.name === 'link') {
            values[index].link = e.target.value;
        }
        else if (e.target.name === 'option') {
            values[index].option = e.target.value;
        }
        setExternalLinks(values);
    }
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Navigation Menu</h6>
                    <Separator className="mb-3" />
                    {externalLinks.length > 0 && externalLinks.map((m, i) => {
                        return (
                            <Row>
                                <Colxx md={4} className='mt-2 text-left'>
                                    <Label>Title</Label>
                                    <Input
                                        type="text"
                                        value={m.title}
                                        onChange={(e) => handleChange(e, i)}
                                        name="title"
                                    />
                                </Colxx>
                                <Colxx md={3} className="mt-2 text-left">
                                    <Label>Option</Label>
                                    <Input
                                        type="select"
                                        name="option"
                                        value={m.option}
                                        onChange={(e) => handleChange(e, i)}
                                    >
                                        <option value={"None"}>Select</option>
                                        {UrlOpenTypes.map((item, i) =>
                                            <option value={item.value}>{item.label}</option>
                                        )}
                                    </Input>
                                </Colxx>
                                {m.option === "OpenContentItem" ?
                                    <Colxx md={4} className="mt-2 text-left">
                                        <Label>Content Item</Label>
                                        <Select
                                            isMulti={false}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            name="link"
                                            value={servicesData.filter(e => e.value === m.link).map(l => l)}
                                            placeholder="Select Content Item"
                                            onChange={(e) => handleChangeSelect(e, i)}
                                            options={
                                                servicesData
                                                    ? reactSelectOptionDiffrentPro(
                                                        servicesData,
                                                        true,
                                                        'value',
                                                        'label',
                                                        ''
                                                    )
                                                    : []
                                            }
                                        />
                                    </Colxx> :
                                    <Colxx md={4} className='mt-2 text-left'>
                                        <Label>Link</Label>
                                        <Input
                                            type="text"
                                            value={m.link}
                                            onChange={(e) => handleChange(e, i)}
                                            name="link"
                                        />
                                    </Colxx>
                                }
                                <Colxx md={1} className='mt-2'>
                                    <Label></Label>
                                    <Button
                                        className="mt-3"
                                        style={{ backGround: 'red' }}
                                        color="danger"
                                        size="xs"
                                        outline
                                        onClick={() => RemoveLinks(i)}
                                    >X</Button>
                                </Colxx>
                            </Row>
                        );
                    })}

                    <Separator className="mt-5" />
                    <Button
                        size="xs"
                        color="success"
                        outline
                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={AddLinks}
                    >
                        + Add Link
                    </Button>
                    <Button
                        size="xs"
                        color="primary"
                        className="ml-2"

                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>);
}